'use client';

import React, { useState } from 'react';
import LoginGate from './LoginGate';
import VerificationForm from './VerificationForm';

export default function VerificationPageClient() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [memberName, setMemberName] = useState('');

  const handleLogin = (name: string) => {
    setIsLoggedIn(true);
    setMemberName(name);
  };

  return (
    <div className="max-w-screen-2xl mx-auto px-4 lg:px-8 xl:px-10 py-10 lg:py-14">
      {!isLoggedIn ? (
        <LoginGate onLogin={handleLogin} />
      ) : (
        <VerificationForm memberName={memberName} />
      )}
    </div>
  );
}